
import React from "react";
import { withTranslation } from "react-i18next";
import Report_ESRS_Icon from "../../images/esrs-reporting.png";
import Report_Icon from "../../images/global-reporting.png";

function RecentReportCard({ t, report }) {

	return (
		<div className="recent_ReportBox">
			<div className="recent_ReportBox_img">
				{
					(report.type == 'ESRS' || report.type == 'DOUBLE_MATERIALITY') &&
					<img src={Report_ESRS_Icon} style={{ width: '45px' }} />
				}
				{
					report.type == 'GRI' &&
					<img src={Report_Icon} />
				}

				{report.status == 'FINALIZED' &&
					<span className="badge bg-badge-Finalized">
						Finalized
					</span>
				}
				{report.status == 'DRAFT' &&
					<span className="badge bg-badge-Inactive">
						Draft
					</span>
				}
				{report.status == 'NOT_STARTED' &&
					<span className="badge bg-badge-New">
						Not Started
					</span>
				}
				{report.status == 'FAILED' &&
					<span className="badge bg-badge-Danger">
						Failed
					</span>
				}
			</div>
			<div className="recent_ReportBox_dt">
				<h6 className="mb-0">{report?.name ?? ''}</h6>
				<small>{report?.daysSinceLastModified ?? 0} Days ago</small>
			</div>
		</div>
	);
};

export default withTranslation()(RecentReportCard);
